interface GraphArrowDownUpDownSVGProps {
  color: string;
  style: React.CSSProperties;
}

const GraphArrowDownUpDownSVG = ({
  color,
  style,
}: GraphArrowDownUpDownSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="48"
    viewBox="0 0 50 48"
    fill="none"
  >
    <g clipPath="url(#clip0_1284_1309)">
      <path
        d="M37.1191 26.1076V41.6002"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9111 23.0365V41.6002"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.0166 16.3846V41.6003"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.80859 14.1217V41.6003"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.703125 0.897705V46.4171H46.2225"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43 31H49V25"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.703125 17.2594V41.6003"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.5026 17.8146C38.4111 16.7231 36.6407 16.7231 35.5491 17.8146C34.4576 18.9062 34.4576 20.6766 35.5491 21.7681C36.6407 22.8597 38.4111 22.8597 39.5026 21.7681"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.9929 8.0916C28.9013 7.00006 27.1309 7.00006 26.0394 8.0916C24.9478 9.18314 24.9478 10.9536 26.0394 12.0451C27.1309 13.1366 28.9013 13.1366 29.9929 12.0451"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9128 14.7435C19.8212 13.652 18.0508 13.652 16.9593 14.7435C15.8677 15.835 15.8677 17.6054 16.9593 18.697C18.0508 19.7885 19.8212 19.7885 20.9128 18.697"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.7839 5.82866C10.6923 4.73713 8.92191 4.73713 7.83037 5.82866C6.73883 6.9202 6.73883 8.69062 7.83037 9.78216C8.92191 10.8737 10.6923 10.8737 11.7839 9.78216"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.9932 12.045L35.6581 17.71"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.4665 11.4061L20.9121 14.7434"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7842 9.7821L16.8863 14.7435"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.6303 28.6824L39.5029 21.7662"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1284_1309">
        <rect
          width="50.1518"
          height="46.9285"
          fill={color}
          transform="translate(0 0.194061)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default GraphArrowDownUpDownSVG;
